<template>
    <PageTemplateContent>
        <BaseHero
            title="Security and auditing"
            data-span-all
        />
        <ContentBlocksText>
            <p>
                1. Data Encryption – MedPeers ensures all data is encrypted. Encryption ensures that even if someone unauthorized accesses the data, they won't be able to read it. End-to-end encryption would ensure that the patient data is secure even when it gets transferred from one device to another.
            </p>
            <p>
                2. Access Controls – MedPeers ensures access control by using strong passwords, 2-factor authentication, and identity and access management systems. Access control measures ensure that only authorized personnel have access to the content. Authorized is here defined as nationally accredited medical professionals. MedPeers will review and verify new registered applications.
            </p>
            <p>
                3. Firewalls – MedPeers utilizes firewalls to filter external traffic and protect against hacking and unauthorized access.
            </p>
            <p>
                4. Regular Audits, security updates and penetration testing – MedPeers will provide regular audits and security updates, including penetration testing, essential to identify vulnerabilities and improve security controls.
            </p>
            <p>
                5. GDPR and HIPAA Compliance – MedPeers complies with the European General Data Protection Regulation (GDPR) and the US Health Insurance Portability and Accountability Act (HIPAA). It ensures the careful processing of personal data by businesses and organizations and sets security and privacy standards for storing, processing and transmitting protected information.
            </p>
            <p>
                6. Secure servers: MedPeers uses secure servers where data can be stored. MedPeers ensures the servers are compliant with all the latest security measures and protocols.
            </p>
        </ContentBlocksText>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | Security and auditing',
    description: 'A secure, peer-reviewed and quality-controlled platform offering educational videos of medical procedures.',
    ogImage: asset('/images/og/default.png')
});
</script>
